export var base = {
  color: '#666666',
  colors: {},
  size: {
    large: '48px',
    xlarge: '96px'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-icons/es6/themes/base.js
// module id = 140
// module chunks = 0